var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrioDore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.97708 61.677L2.25202 68.1604L0.840599 73.8532C0.213303 78.439 0.997423 82.0761 3.19296 84.6062C6.95674 89.0339 13.7002 89.5083 15.7389 89.5083H15.8957H83.8005L24.6779 55.3517C24.6779 55.3517 20.13 52.6635 15.1116 52.6635C13.857 52.6635 12.4456 52.8216 11.191 53.296C8.05451 54.561 5.54532 57.2493 3.97708 61.677Z",
    fill: "#FAF1E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1688 30.8412C19.346 34.3202 18.2482 37.9572 18.8755 41.278C20.1301 47.7614 27.344 51.8728 27.344 52.031L86.153 86.3456L52.1222 26.8879C52.1222 26.7298 47.888 19.4557 41.4582 18.3488C40.8309 18.1907 40.2036 18.1907 39.5763 18.1907C36.7535 18.1907 33.9306 19.4557 30.951 21.8277L26.8735 25.9392L22.1688 30.8412Z",
    fill: "#F5E5CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5314 3.48446C57.2972 5.06578 54.6312 7.59589 53.5334 10.9167C51.3379 17.0838 55.5721 24.3579 55.5721 24.516L89.4461 84.1318V15.3444C89.4461 15.1862 89.4461 6.80523 84.5846 2.53567C82.5459 0.796214 80.0367 0.0055542 76.9002 0.0055542C75.9592 0.0055542 74.8615 0.163687 73.7637 0.321819L68.2749 1.74501L61.5314 3.48446Z",
    fill: "#F0D7AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrioDore);
export default __webpack_public_path__ + "static/media/trio-dore.7755ae9c21f1527d78e5452fb170113d.svg";
export { ForwardRef as ReactComponent };